import { render } from "./Spanish.vue?vue&type=template&id=19b41852&ts=true"
import script from "./Spanish.vue?vue&type=script&lang=ts"
export * from "./Spanish.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__